import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import { Input as SUIInput } from 'semantic-ui-react';
import {IMaskMixin} from 'react-imask';

import { View } from '../View';
import Dropdown from '../Dropdown';
import Text from '../Text';
import TextArea from '../TextArea';

import { styleUtils } from '../../utils';

import styles from './styles';
import CountrySelector from "../Select/CountrySelector";
import FORMAT_PATTERNS from "../../constants/format";
import {COLORS} from "../../design/tokens";

const { style } = styleUtils;

const Container = style(View, styles.container);
const SInput = style(SUIInput, styles.input);
const StyledInput = style('input', styles.input);
const SMessage = style(Text, styles.message);
const STextArea = style(TextArea, styles.textArea);
const DropdownContainer = style(View, styles.dropdownContainer);
const InputContainer = style(View, styles.inputContainer);
const DropdownLabel = style(Text);

const MaskedStyledInput = IMaskMixin(({inputRef, ...props}) => (
  <StyledInput {...props} ref={inputRef} />
));

const Input = (props) => {
  const setTextInputRef = useRef(null);
  const [prefix, setPrefix] = useState('1');
  const PREFIX =  `+${prefix.split('').join('\\')}`

  const handleDropdownChange = value => {
    const { onChange } = props;
    const val = value.replace(/[^0-9]+/g, '');
    setTextInputRef.current.element.focus();
    onChange && onChange({ target: { value: ' '}});

    setPrefix(val);
  };

  const handleMaskedInputChange = (value) => {
    const { onChange } = props;
    onChange && onChange({ target: { value }});
  };

    const {
      textArea,
      label,
      sublabel,
      message,
      required,
      dropdownLabel,
      dropdownMessage,
      dropdownItems,
      dropdownOnChange,
      value,
      innerRef,
      mask,
      showCountrySelector,
      ...restOfProps
    } = props;


    return (
      <Container>
        {label && (
          <Text size="small" uppercase weight="600" color={COLORS.TEXT.BLACK} required={required}>
            {label}
          </Text>
        )}
        {sublabel && <Text size="small">{sublabel}</Text>}
        {textArea ? (
          <STextArea {...restOfProps} />
        ) : (
          <InputContainer className={showCountrySelector ? 'with-country-selector' : ''}>
          { showCountrySelector &&
            <CountrySelector onChange={handleDropdownChange}/>
          }
            {
              mask && (
                <SInput
                  value={value}
                  {...restOfProps}
                >
                  <MaskedStyledInput
                    ref={setTextInputRef}
                    mask={FORMAT_PATTERNS.phone.replace('PREFIX', PREFIX)}
                    lazy={false}
                    unmask={false}
                    placeholderChar="_"
                    value={value}
                    onAccept={handleMaskedInputChange}
                    {...restOfProps}
                  />
                </SInput>
              )
            }
            {
              !mask && <SInput
                ref={setTextInputRef}
                value={value}
                {...restOfProps}
              />
            }
          </InputContainer>
        )}
        {
          dropdownItems &&
          <>
            <DropdownMessage
              dropdownOnChange={handleDropdownChange}
              dropdownMessage={dropdownMessage}
              dropdownLabel={dropdownLabel}
              dropdownItems={dropdownItems}
            />
            <Message message={message} error={restOfProps.error} />
          </>
        }
      </Container>
    );
  }


const DropdownMessage = ({
  dropdownLabel,
  dropdownMessage,
  dropdownItems,
  dropdownOnChange
}) =>
  dropdownMessage && dropdownItems ? (
    <DropdownContainer>
      <DropdownLabel size="small">
        {dropdownMessage ? `${dropdownMessage} ` : null}
        <Dropdown
          text={dropdownLabel}
          items={dropdownItems}
          onChange={dropdownOnChange}
        />
      </DropdownLabel>
    </DropdownContainer>
  ) : null;

const Message = ({ message, error }) =>
  message ? (
    <SMessage error={error} size="small">
      {message}
    </SMessage>
  ) : null;

Input.propTypes = {
  ...SUIInput.propTypes,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  message: PropTypes.any,
  error: PropTypes.bool,
  height: PropTypes.string,
  textArea: PropTypes.bool,
  required: PropTypes.bool,
  dropdownMessage: PropTypes.string,
  dropdownOnChange: PropTypes.func,
  showCountrySelector: PropTypes.bool,
  mask: PropTypes.string
};

Input.defaultProps = {
  error: false,
  required: false,
  textArea: false,
  height: '176px',
  mask: null,
  showCountrySelector: false
};

export default Input;
